import { InsightModel } from "@doitintl/cmp-models";
import { getCollection } from "@doitintl/models-any";
import { useDocumentDataOnce } from "@doitintl/models-hooks";

import { useCustomerContext } from "../../../../../Context/CustomerContext";

export const useRelevantTrustedAdvisorCustomerAccounts = () => {
  const { customerOrPresentationModeCustomer } = useCustomerContext();

  const [trustedAdvisorCustomerDoc, loading, error] = useDocumentDataOnce(
    getCollection(InsightModel)
      .doc("trusted-advisor")
      .collection("relevantCustomersAccounts")
      .doc(customerOrPresentationModeCustomer.id)
  );

  if (loading) {
    return undefined;
  }

  if (error) {
    return null;
  }

  return trustedAdvisorCustomerDoc?.accounts;
};
